import React from 'react';
import './DocumentChatShell.css';

export interface DocumentChatShellProps {
  /** Cancel / back — typically exits to fill-in checklist */
  onBack: () => void;
  cancelLabel: string;
  /** Scrollable main area (thread + composer) */
  children: React.ReactNode;
}

/**
 * Shared chrome for definition-driven document chats (worker registry, future PDFs).
 * Matches visual weight of GeneralProfile / intro chats (Option A shell).
 */
const DocumentChatShell: React.FC<DocumentChatShellProps> = ({ onBack, cancelLabel, children }) => {
  return (
    <div className="doc-chat-shell">
      <div className="doc-chat-shell__card">
        <header className="doc-chat-shell__top">
          <button type="button" className="doc-chat-shell__cancel-pill" onClick={onBack}>
            <span className="doc-chat-shell__cancel-x" aria-hidden>
              ×
            </span>
            {cancelLabel}
          </button>
        </header>
        <div className="doc-chat-shell__body">{children}</div>
      </div>
    </div>
  );
};

export default DocumentChatShell;
